import { get, upperCase, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { SenaryParagraphHeading } from 'components/Headings';
import IconButton from 'components/IconButton';
import { ICON_MAP, TYPES } from 'constants/topNavigation';
import Theme from 'styles/theme';

const ARIA_CONTROLS = 'top-navigation-drawer-desktop';
const ICON_SIZE = 24;

const TopNavigationHeaderDesktopIcon = ({
  l1Option,
  closeTopNavigation,
  setCurrentTopNavigationNode,
  trackNavigation,
  trackNavigationClick,
  isTopNavigationOpen,
}) => {
  const Icon = get(ICON_MAP, upperCase(l1Option.icon));
  const handleClick = () => {
    trackNavigation(l1Option.linkUrl);
    trackNavigationClick({
      navigationType: TYPES.GLOBAL,
      navigationLevel1: l1Option.label,
      navigationSource: window.location.href,
    });
  };

  return (
    <div className="TopNavigationHeaderDesktopIcon">
      {isEmpty(l1Option.subNavigations) && l1Option.linkUrl && Icon ? (
        <a
          href={l1Option.linkUrl}
          onClick={() => handleClick()}
          className="TopNavigationHeaderDesktop__icon"
          aria-label={l1Option.label}
        >
          <Icon />
        </a>
      ) : (
        <IconButton
          onClick={
            l1Option.isActive
              ? () => closeTopNavigation()
              : () => setCurrentTopNavigationNode(l1Option.id)
          }
          className="TopNavigationHeaderDesktop__button"
          aria-controls={ARIA_CONTROLS}
          aria-expanded={isTopNavigationOpen}
          aria-label={l1Option.label}
        >
          <div className="TopNavigationHeaderDesktop__button-content" key={l1Option.label}>
            {l1Option.icon ? (
              <Icon />
            ) : (
              <SenaryParagraphHeading>{l1Option.label}</SenaryParagraphHeading>
            )}
          </div>
        </IconButton>
      )}
      <style jsx>{`
        .TopNavigationHeaderDesktop__icon {
          display: table;
          vertical-align: middle;
          margin: ${Theme.get('spacing') * 3}px 0 ${Theme.get('spacing') * 3}px
            ${Theme.get('spacing') * 3}px;
          width: ${ICON_SIZE}px;
        }
      `}</style>
      <style global jsx>
        {`
          .TopNavigationHeaderDesktop__button {
            margin: 0 0 0 ${Theme.get('spacing') * 3}px;
          }
        `}
      </style>
    </div>
  );
};

TopNavigationHeaderDesktopIcon.propTypes = {
  l1Option: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    subNavigations: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    icon: PropTypes.string,
  }).isRequired,
  closeTopNavigation: PropTypes.func.isRequired,
  setCurrentTopNavigationNode: PropTypes.func.isRequired,
  trackNavigation: PropTypes.func.isRequired,
  trackNavigationClick: PropTypes.func.isRequired,
  isTopNavigationOpen: PropTypes.bool.isRequired,
};

export default TopNavigationHeaderDesktopIcon;
